import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onBeforeUnmount, ref, watch } from 'vue';
import { debounce } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageWithAutoSizes',
  props: {
    src: null,
    srcset: null,
    altText: { default: '' },
    lazyload: { type: Boolean, default: false }
  },
  emits: ['resize', 'loaded', 'error', 'click'],
  setup(__props: any, { emit }) {

const props = __props as { src: string, srcset: string, altText: string, lazyload: boolean }





const imageWidth = ref(0);
const hasIncreasedImageWidth = ref(false); // whether the image size is the original or an upgrade, due to viewport having been enlarged

const loadingMethod = computed<'lazy' | 'eager'>(() => {
    // load lazy if lazyload is true or if the image has changed due an enlargement of the container (getting the higher resolution image is no rush)
    return (props.lazyload || hasIncreasedImageWidth.value) ? 'lazy' : 'eager';
});

const rootElement = ref(null);

const getRandomIntegerInInterval = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};

const updateImageWidthDebounced = debounce((newWidth: number) => {
    hasIncreasedImageWidth.value = true;
    imageWidth.value = newWidth;
}, getRandomIntegerInInterval(500, 1000)); // Randomize the debounce time in order to "prevent" that multiple images are replaced at the exact same time

const resizeObserver = new ResizeObserver((entries) => {
    if (entries && (entries.length > 0) && entries[0].contentRect && entries[0].contentRect.width) {
        const newWidth = entries[0].contentRect.width;

        if (imageWidth.value === 0) {
            imageWidth.value = newWidth;
        } else {
            const imageIsLarger = Math.round(newWidth) > Math.round(imageWidth.value);
            if (imageIsLarger) {
                // We do not update straight away, but with debounce because:
                // 1: It is not that high priority to get a bigger image fast
                // 2: A lot of image replacements in a short period of time would hurt performance
                updateImageWidthDebounced(newWidth);
            }
        }
        emit('resize');
    }
});

const resetState = () => {
    hasIncreasedImageWidth.value = false;
    if (rootElement.value) {
        imageWidth.value = (rootElement.value as HTMLElement).clientWidth;
    }
};

// Reset state in case any of the props changes
watch(() => ({ ...props }), () => {
    resetState();
}, { deep: true });

onMounted(() => {
    resetState();
    if (rootElement.value) {
        resizeObserver.observe(rootElement.value);
    }
});

onBeforeUnmount(() => {
    if (rootElement.value) {
        resizeObserver.disconnect();
    }
});

return { __sfc: true,emit, props, imageWidth, hasIncreasedImageWidth, loadingMethod, rootElement, getRandomIntegerInInterval, updateImageWidthDebounced, resizeObserver, resetState }
}

})